export type Service = {
  slug: string;
  num: string;
  title: string;
  short: string;
  image: string;
  secondaryImage?: string;
  positioning: string;
  whatWeDo: string[];
  approach: string;
  relatedProjectSlugs: string[];
};

export const services: Service[] = [
  {
    slug: "whole-home",
    num: "01",
    title: "Whole Home Remodeling",
    short: "Comprehensive renovations that reorganize how a home actually lives.",
    image: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-ridge-house-hero.webp",
    secondaryImage: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-ridge-house-living-dining.webp",
    positioning: "Comprehensive residential renovations, delivered as a single integrated design and construction effort.",
    whatWeDo: [
      "Interior architecture and space planning",
      "Structural reconfiguration and additions",
      "Custom millwork, joinery and stonework",
      "Full construction management",
      "Material, lighting and finish direction",
    ],
    approach: "A single team leads design, documentation and construction, so every decision — from the plan to the last piece of hardware — is resolved together.",
    relatedProjectSlugs: ["ridge-house"],
  },
  {
    slug: "kitchens",
    num: "02",
    title: "Kitchens",
    short: "Warm, architectural kitchens designed around daily life.",
    image: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-oakline-kitchen-hero.webp",
    secondaryImage: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-oakline-kitchen-alt.webp",
    positioning: "Kitchens designed as the architectural heart of the home, resolved down to the last drawer.",
    whatWeDo: [
      "Custom cabinetry and joinery",
      "Stone and material specification",
      "Appliance integration and planning",
      "Lighting and electrical layout",
      "Full renovation delivery",
    ],
    approach: "We study how the family uses the kitchen through the day, then compose the room as a single architectural volume around that rhythm.",
    relatedProjectSlugs: ["oakline-kitchen"],
  },
  {
    slug: "bathrooms",
    num: "03",
    title: "Bathrooms",
    short: "Calm, restorative bathrooms with honest materials.",
    image: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-stonewell-bath-hero.webp",
    secondaryImage: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-stonewell-bath-alt.webp",
    positioning: "Primary and family bathrooms rebuilt as quiet, restorative rooms.",
    whatWeDo: [
      "Custom vanities and stone counters",
      "Shower and wet-area waterproofing",
      "Fixture and fitting specification",
      "Radiant heating and ventilation",
      "Complete renovation delivery",
    ],
    approach: "We design the room as one continuous material envelope, then resolve every fixture, joint and light source inside it.",
    relatedProjectSlugs: ["stonewell-bath"],
  },
  {
    slug: "additions",
    num: "04",
    title: "Additions",
    short: "Additions that read as one piece with the original home.",
    image: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_service-additions-extension.webp",
    secondaryImage: "https://public.readdy.ai/ai/img_res/sandbox/7ffb55af637baf94343ad3a63d8fcd76/f86dfac6-e65e-48c9-9f8a-ad5fd5c49543_project-ridge-house-living-dining.webp",
    positioning: "Rear, side and second-story additions that respect the original architecture and the site.",
    whatWeDo: [
      "Feasibility and planning studies",
      "Structural design and engineering",
      "Envelope, roofing and windows",
      "Interior integration with the existing home",
      "Full permitting and construction",
    ],
    approach: "Every addition begins with the existing home. We add only what is required to unlock the plan you actually want to live in.",
    relatedProjectSlugs: ["ridge-house"],
  },
];

export const getService = (slug: string) => services.find(s => s.slug === slug);